module.exports = __webpack_public_path__ + "img/topic-active-rule.363bf01c.png";